import { http } from '../axios';
import { shopPrefix } from '../../config';

export type SendForApprovalParams = {
    listId: string;
    userEmail: string;
};

const url = `${shopPrefix}/v1/reservelist/:reserveListId/approverequest`;

export const sendForApproval = async ({ listId, userEmail }: SendForApprovalParams) => {
    return http
        .get<void>(url, {
            pathParams: { reserveListId: listId },
            params: { userEmail }
        })
        .then(res => res.data);
};
